import { call, put } from 'redux-saga/effects';
import api from '../../../services/api';
import actions from '../actions';
import { User } from '../../../common/types/CombinedEntry';

export function* loadPilotsWorker(companyID: string) {
  if (!companyID) {
    throw new Error('Failed to load pilots. There are missed params.');
  }

  try {
    const queryParams = { limit: 1000, order: 'profile.last_name asc' };
    const {
      data: { Data },
    } = yield call(api.get, `/v1/companies/${companyID}/users`, {
      params: queryParams,
    });

    const adminProfiles = Data.filter(
      (u: { Profile: { PilotLicenseNumber: string } }) => !u.Profile?.PilotLicenseNumber,
    ).map((pilot: User) => pilot.Profile);

    const pilotProfiles = Data.filter(
      (u: { Profile: { PilotLicenseNumber: string } }) => !!u.Profile?.PilotLicenseNumber,
    ).map((pilot: User) => pilot.Profile);

    yield put(actions.setCompanyUsers(Data));
    yield put(actions.setPilotProfiles(pilotProfiles));

    yield put(actions.setAllProfiles([...adminProfiles, ...pilotProfiles]));
  } catch (err) {
    console.log('Failed to load pilots: ', err);
  }
}
